import { useTranslation } from "react-i18next";
import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";

import { useJobSourceTenantDetailsBreadcrumbs } from "../hooks/useJobSourceTenantDetailsBreadcrumbs";

import ModernPageLayout from "@/components/layout/ModernPageLayout";
import Tabs, { TabItemProps } from "@/components/ui/v2/tabs";
import { ROUTES } from "@/constants/routes";
import { ModuleName } from "@/features/integrations/utils/module-name";
import { encodeSlug } from "@/features/integrations/utils/slug";

function JobSourceTenantDetailPage() {
  const { t } = useTranslation();
  const { integrationName } = useParams<{ integrationName: string }>();
  const location = useLocation();
  const { breadcrumbs } = useJobSourceTenantDetailsBreadcrumbs();

  const basePath = `/${ROUTES.integrations}/${integrationName}/${encodeSlug(ModuleName.JobSource)}`;

  // If we're on the exact base path (no nested route), redirect to /clients
  const isExactBasePath = location.pathname === basePath;
  if (isExactBasePath) {
    return <Navigate to={`${basePath}/clients`} replace />;
  }

  // Determine active tab based on current route
  const getActiveTabId = () => {
    if (location.pathname.includes("/webhooks")) {
      return "webhooks";
    }
    return "clients";
  };

  const tabs: TabItemProps[] = [
    {
      id: "clients",
      label: t("common.clients"),
      href: `${basePath}/clients`,
      content: <></>,
    },
    {
      id: "webhooks",
      label: t("webhooks.recruitnow.clientPageTitle"),
      href: `${basePath}/webhooks`,
      content: <></>,
    },
  ];

  return (
    <ModernPageLayout breadcrumbs={breadcrumbs}>
      <Tabs
        defaultTabId={getActiveTabId()}
        tabs={tabs}
      />
      <Outlet />
    </ModernPageLayout>
  );
}

export default JobSourceTenantDetailPage;
